<template>
  <div class="row">
    <c-card title="독성여부 체크" class="cardClassDetailForm">
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn
            v-if="!disabled && editable"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="save"
            :mappingType="saveType"
            label="저장"
            icon="save"
            @beforeAction="saveAccident"
            @btnCallback="saveCallback" 
          />
        </q-btn-group>
      </template>>
      <template slot="card-detail">
        <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
          <c-checkbox
            :editable="editable"
            :disabled="disabled"
            :isFlag="true"
            type="edit"
            name="toxicFlag"
            label="독성여부"
            v-model="tabParam.toxicFlag"
          ></c-checkbox>
        </div>
      </template>
    </c-card>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-table
        ref="equipTable"
        title="사고관련 설비 목록"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :isExcelDown="false"
        noDataLabel="설비를 추가하세요."
        :hideBottom="true"
        :editable="editable && !disabled"
        rowKey="equipmentCd"
        selection="multiple"
        @linkClick="linkClick1"
      >
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn v-if="editable && !disabled" :showLoading="false" label="추가" icon="add" @btnClicked="addEquipment" />
            <c-btn v-if="editable && !disabled && grid.data.length > 0" :showLoading="false"  label="제외" icon="remove" @btnClicked="removeEquipment" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" topClass="topcolor-orange">
      <c-table
        ref="chemTable"
        title="사고관련 화학물질 목록"
        :columns="grid2.columns"
        :gridHeight="grid2.height"
        :data="grid2.data"
        :filtering="false"
        :isExcelDown="false"
        :columnSetting="false"
        :usePaging="false"
        :hideBottom="true"
        noDataLabel="화학물질을 추가하세요."
        :editable="editable && !disabled"
        rowKey="materialCd"
        selection="multiple"
        @linkClick="linkClick2"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && !disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="addChem" />
            <c-btn v-if="editable && !disabled && grid2.data.length > 0" label="제외" :showLoading="false" icon="remove" @btnClicked="removeChem" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'accident-equipment',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimAccidentId: '',
        stepCd: '',
        count: 0,
        updateBtnProps: {
          data: {
            title: '사고',
            flag: false,
          },
          flagCondition: false,
          btnEditable: false
        }
      }),
    },
    tabParam: {
      type: Object,
      default: () => ({
        plantCd: '',
        iimAccidentId: '',
        toxicFlag: 'N',
        accidentMaterialModelList: [],
        accidentStatusCd: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid: {
        columns: [
          {
            name: 'equipmentTypeName',
            field: 'equipmentTypeName',
            label: '설비유형',
            style: 'width:100px',
            align: 'center',
            sortable: false
          },
          {
            name: 'equipmentNo',
            field: 'equipmentNo',
            label: '설비관리번호',
            style: 'width:100px',
            type: 'link',
            align: 'center',
            sortable: false
          },
          {
            name: 'equipmentName',
            field: 'equipmentName',
            label: '설비명',
            style: 'width:200px',
            align: 'left',
            sortable: false
          },
          {
            name: 'relatedLawsName',
            field: 'relatedLawsName',
            label: '관련법규',
            align: 'left',
            style: 'width:300px',
            sortable: false
          },
        ],
        data: [],
        height: '280px'
      },
      grid2: {
        columns: [
          {
            name: 'materialCd',
            field: 'materialCd',
            type: 'link',
            label: '자재코드',
            align: 'center',
            sortable: false

          },
          {
            name: 'casNo',
            field: 'casNo',
            label: 'casNo',
            align: 'center',
            sortable: false

          },
          {
            name: 'materialName',
            field: 'materialName',
            label: '화학자재',
            align: 'center',
            sortable: false
          },
        ],
        data: [],
        height: '280px'
      },
      toxicFlagItems: [
        { code: 'Y', codeName: 'YES' },
        { code: 'N', codeName: 'NO' },
      ],
      save: {
        plantCd: '',
        iimAccidentId: '',
        toxicFlag: 'N',
        accidentMaterialModelList: [],
        accidentStatusCd: '',
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: 'transactionConfig.sop.iim.accident.process.insert.url',
      saveType: 'POST',
      isSave: false,
      title: '',
    };
  },
  computed: {
    disabled() {
      return (this.tabParam.accidentStatusCd === 'ISPC000005' 
          || this.tabParam.approvalStatusCd === 'ASC0000001')
        && !this.popupParam.updateBtnProps.data.flag
    },
  },
  watch: {
    'grid.data'() {
      this.tabParam.accidentMaterialModelList = (this.$_.concat(this.grid.data, this.grid2.data));
    },
    'grid2.data'() {
      this.tabParam.accidentMaterialModelList = (this.$_.concat(this.grid.data, this.grid2.data));
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      this.editable = this.$route.meta.editable;
      
      this.updateUrl = transactionConfig.sop.iim.accident.process.update.relate.url;

      // list setting
      this.getDetail();
    },
    getDetail() {
      this.$_.forEach(this.tabParam.accidentMaterialModelList, _item => {
        if (_item.equipmentMaterialTypeCd === 'EQUIP') {
          this.grid.data.push(_item) // 설비
        } else {
          this.grid2.data.push(_item) // 화학자재
        }
      })
    },
    /* eslint-disable no-unused-vars */ 
    addEquipment() {
      // 초기에는 userId에 tempId를 부여
      this.popupOptions.title = '사고 설비 검색'; // 사고설비 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/equip/equipPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeEquipmentPopup;
    },
    closeEquipmentPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.grid.data, {
            equipmentCd: _item.equipmentCd,
          });
          if (index === -1) {
            this.grid.data.splice(0, 0, {
              iimAccidentId: this.tabParam.iimAccidentId,
              equipmentMaterialTypeCd: 'EQUIP',
              managementDepts: _item.managementDepts,
              equipmentTypeName: _item.equipmentTypeName,
              checkDeptCd: _item.managementDepts,
              equipmentName: _item.equipmentName,
              equipmentNo: _item.equipmentNo,
              equipmentCd: _item.equipmentCd,
              relatedLawsName: _item.relatedLawsName,
              regUserId: this.$store.getters.user.userId,
              chgUserId: this.$store.getters.user.userId
            })
          }
        })
      }
    },
    removeEquipment() {
      let selectData = this.$refs['equipTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.grid.data = this.$_.reject(this.grid.data, { equipmentCd: item.equipmentCd })
        })
      }
    },
    addChem() {
      // 초기에는 userId에 tempId를 부여
      this.popupOptions.title = '사고 화학자재 검색'; // 사고 화학자재 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/material/chemMaterialPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeChemPopup;
    },
    closeChemPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.grid2.data, {
            mdmChemMaterialId: _item.mdmChemMaterialId,
          });
          if (index === -1) {
            this.grid2.data.splice(0, 0, {
              iimAccidentId: this.tabParam.iimAccidentId,
              equipmentMaterialTypeCd: 'CHEM',
              materialCd: _item.materialCd,
              mdmChemMaterialId: _item.mdmChemMaterialId,
              casNo: _item.casNo,
              materialName: _item.materialName,
              regUserId: this.$store.getters.user.userId,
              chgUserId: this.$store.getters.user.userId
            })
          }
        })
      }
    },
    removeChem() {
      let selectData = this.$refs['chemTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          this.grid2.data = this.$_.reject(this.grid2.data, item)
        });
      }
    },
    saveAccident() {
      this.saveUrl = this.updateUrl;
      this.saveType = 'PUT';
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.tabParam.accidentMaterialModelList = 
          this.$_.concat(this.grid.data, this.grid2.data);

          if(this.tabParam.iimAccidentId) {
            this.$set(this.save, 'iimAccidentId',  this.tabParam.iimAccidentId);
            this.$set(this.save, 'plantCd',  this.tabParam.plantCd);
            this.$set(this.save, 'toxicFlag',  this.tabParam.toxicFlag);
            this.$set(this.save, 'accidentMaterialModelList',  this.tabParam.accidentMaterialModelList);
            this.$set(this.save, 'accidentStatusCd',  this.tabParam.accidentStatusCd);
          }
          
          this.tabParam.regUserId = this.$store.getters.user.userId
          this.tabParam.chgUserId = this.$store.getters.user.userId
          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
    },
    linkClick1(data) {
      this.popupOptions.title = '관련 설비 상세';
      this.popupOptions.param = 
      this.popupOptions.param = {
        equipmentCd: data ? data.equipmentCd : '',
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/fim/equipmentDetail.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    linkClick2(data) {
      this.popupOptions.title = '관련 화학물질 상세';
      this.popupOptions.param = 
      this.popupOptions.param = {
        mdmChemMaterialId: data ? data.mdmChemMaterialId : '',
        plantCd: data ? this.tabParam.plantCd : '',
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/mam/chemDetail.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  }
};
</script>
